import { useEffect, useState } from 'react';
import { Table, TableHeader, TableBody, TableRow, TableHead, TableCell } from '@/components/ui/table';
import { Skeleton } from '@/components/ui/skeleton';
import { listNewsletterSubscribers } from '@/lib/api';

export const AdminNewsletterTab = () => {
  const [subs, setSubs] = useState(null);

  useEffect(() => {
    listNewsletterSubscribers().then(setSubs).catch(() => setSubs([]));
  }, []);

  if (!subs) return <Skeleton className="h-64 rounded-2xl bg-[#141416]" />;

  return (
    <div className="rounded-2xl border border-[hsl(var(--lxra-border))] bg-[#0F0F10] overflow-hidden" data-testid="admin-newsletter-table">
      <Table>
        <TableHeader>
          <TableRow className="border-[hsl(var(--lxra-border))] hover:bg-transparent">
            <TableHead className="text-[hsl(var(--lxra-muted))]">Email</TableHead>
            <TableHead className="text-[hsl(var(--lxra-muted))]">Subscribed</TableHead>
          </TableRow>
        </TableHeader>
        <TableBody>
          {subs.length === 0 && (
            <TableRow className="border-[hsl(var(--lxra-border))]">
              <TableCell colSpan={2} className="text-center text-[hsl(var(--lxra-muted))] py-10">
                No subscribers yet.
              </TableCell>
            </TableRow>
          )}
          {subs.map((s) => (
            <TableRow key={s.id} className="border-[hsl(var(--lxra-border))] hover:bg-[#141416]">
              <TableCell className="text-[hsl(var(--lxra-fg))]">{s.email}</TableCell>
              <TableCell className="text-[hsl(var(--lxra-muted))] text-xs">
                {new Date(s.subscribed_at).toLocaleString()}
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </div>
  );
};
